module.exports = __webpack_public_path__ + "prod/1.42.2/img/yinchegn-icon.4c5cf580.png";